import axios from "axios";
import RestService from "../../../helpers/RestService";

axios.defaults.headers.common = {
  'Accept': 'application/json, text/plain',
  'X-CSRF-Token': RestService.getCsrfToken(),
  'X-Requested-With' : 'XMLHttpRequest',
};

axios.defaults.headers.post['Content-Type'] = 'application/json';


export async function getFolderPresentation(id = 0) {
  
    try {
      const {data} = await axios.post('/api/folder/presentations', {id});

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        return data.payload;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
}

export async function getFolders() {
  
    try {
      const {data} = await axios.get('/api/folders/get');

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        return data.payload;
      } else {
        return []
      }
    } catch (error) {
     return []; 
    }
  
}

export async function createPresentation(body) {
    try {
      const {data} = await axios.post('/api/presentation/post', {
        ...body, 
      });

      let payload = [];

      if(data.errcode == 200) {
        payload = data.payload;
        return payload;
      } else {
        // TODO error
        return Promise.reject({message: 'Bag request'})
      }
    } catch (error) {
      return Promise.reject({message: 'Bag request'})      
    }
}


export async function addSlide(body) {
    try {
      const {data} = await axios.post('/api/presentation-item/post', {
        ...body, 
      });

      if(data.errcode == 200) {
        return data.payload;
      } else {
        return Promise.reject({message: 'Bag request'})
      }
      
    } catch (error) {
      return null;
      
    }
}

export async function addSlides(body) {
  console.log("addSlides -> body", body)
  try {
    const {data} = await axios.post('/api/presentation-item/posts', {
      ...body, 
    });

    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
    
  } catch (error) {
    console.log("addSlides -> error", error)
    return null;
    
  }
}


export async function updateQuestionStatus(body) {
  try {
    const {data} = await axios.post('/api/mcq1/update-status', {
      ...body, 
    });

    if(data.errcode == 200) {
      return data.payload;
    } else {
      return Promise.reject({message: 'Bag request'})
    }
    
  } catch (error) {
    return null;
    
  }
}


// WEBPACK FOOTER //
// ./yii2/frontend/frontend-assets/src/components/QbmPage/QbmPresentation/actions.js